import setGlobalProperty from '@/helpers/setGlobalProperty';

const appleAuth = (function aAuth() {
  let AppleID;

  const hasLoadedAppleAuth = () => !!(AppleID?.auth);

  const installClient = () => new Promise((resolve) => {
    const el = document.createElement('script');
    el.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    el.async = true;
    el.defer = true;

    // eslint-disable-next-line no-multi-assign
    el.onreadystatechange = el.onload = function onLoad() {
      if (!el.readyState || /loaded|complete/.test(el.readyState)) {
        setTimeout(() => {
          AppleID = window.AppleID;
          resolve();
        }, 500);
      }
    };

    document.head.appendChild(el);
  });

  const initializeClient = (config) => {
    AppleID.auth.init({
      clientId: config.clientId,
      scope: config.scope,
      redirectURI: config.redirectURI,
      state: config.state,
      nonce: config.nonce,
      usePopup: true,
    });
  };

  function Auth() {
    this.load = (config) => {
      this.loading = new Promise((resolve, reject) => {
        installClient()
          .then(() => {
            initializeClient(config);
            resolve();
          }).catch((error) => {
            // eslint-disable-next-line no-console
            console.error(error);
            reject(error);
          });
      });

      return this.loading;
    };

    this.signIn = () => this.loading.then(async () => {
      if (!hasLoadedAppleAuth()) {
        throw new Error('Apple ID could not be loaded.');
      }

      return AppleID.auth.signIn();
    });
  }

  return new Auth();
}());

export default function appleAuthPackage(Vue, options) {
  if (Vue.prototype.$appleAuth) {
    return;
  }

  setGlobalProperty(Vue, '$appleAuth', appleAuth);

  appleAuth.load(options);
}
